module.exports = __webpack_public_path__ + "img/privy-logo-alt.31bbbc38.png";